var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg27E06Fbd92F13D40Bb41991Bcd741A47(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.844,
    height: 19.805,
    viewBox: "0 0 15.844 19.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_27e06fbd92f13d40bb41991bcd741a47",
    "data-name": "27e06fbd92f13d40bb41991bcd741a47",
    d: "M5.791,13.418a26.664,26.664,0,0,1,4.283,0,17.47,17.47,0,0,1,2.313.291c1.653.335,2.733.881,3.2,1.762a2.439,2.439,0,0,1,0,2.194c-.463.881-1.5,1.462-3.213,1.762a16.6,16.6,0,0,1-2.313.3A19.72,19.72,0,0,1,7.89,19.8H6.58a6.248,6.248,0,0,0-.8-.053,15.833,15.833,0,0,1-2.313-.291C1.816,19.144.737,18.58.274,17.7A2.416,2.416,0,0,1,0,16.589,2.389,2.389,0,0,1,.266,15.47c.454-.881,1.533-1.454,3.2-1.762A16.918,16.918,0,0,1,5.791,13.418ZM7.925,0a5.275,5.275,0,0,1,5.2,5.348,5.275,5.275,0,0,1-5.2,5.348,5.275,5.275,0,0,1-5.2-5.348A5.275,5.275,0,0,1,7.925,0Z",
    fill: "#6d4eec"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg27E06Fbd92F13D40Bb41991Bcd741A47);
export default __webpack_public_path__ + "static/media/27e06fbd92f13d40bb41991bcd741a47.ef6096b3a15b1d05e80ea61605d35f89.svg";
export { ForwardRef as ReactComponent };